import { useEffect, useState } from 'react';

/**
 * Returns 'month' if the browser supports input type="month" (Chrome, Safari, Edge),
 * otherwise 'date' for fallback (e.g. Firefox).
 */
export const useMonthInputSupport = (): 'month' | 'date' => {
  const [inputType, setInputType] = useState<'month' | 'date'>('date');

  useEffect(() => {
    const input = document.createElement('input');
    input.setAttribute('type', 'month');
    setInputType(input.type === 'month' ? 'month' : 'date');
  }, []);

  return inputType;
};
